export default "__VITE_ASSET__CIJm8ESQ__"